/* import __COLOCATED_TEMPLATE__ from './empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

interface Args {
  icon?: InterfaceIconName;
  title: string;
  description?: string;
  descriptionForCta?: string;
  classNames?: string;
  includeCtaToConnect?: boolean;
}

export default class EmptyState extends Component<Args> {
  @service declare appService: any;
  @service declare finStandaloneService: FinStandaloneService;
  @tracked showZendeskConnectDrawer = false;

  get includeCtaToConnect(): boolean {
    return this.args.includeCtaToConnect ?? false;
  }

  get isZendeskPlatform() {
    return this.appService.app.hasStandalonePlatform('zendesk');
  }

  get shouldShowCta() {
    return (
      this.includeCtaToConnect &&
      !this.finStandaloneService.isZendeskConnectedWithSyncingEnabled &&
      this.appService.app.canUseConversationImporterUi &&
      this.isZendeskPlatform
    );
  }

  @action
  closeZendeskConnectDrawer() {
    this.showZendeskConnectDrawer = false;
  }

  @action
  openZendeskConnectDrawer() {
    this.showZendeskConnectDrawer = true;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Custom::EmptyState': typeof EmptyState;
    'reporting/custom/empty-state': typeof EmptyState;
  }
}
